<template>
  <div>
    
    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div class="toolbar-pagetop">
      <v-container pa-0 pb-2 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="pl-4 pr-4 pt-4">

          <v-breadcrumbs>
            <v-breadcrumbs-item to="/dashboard/">
              Home
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item to="/inventory/inventory-definitions">
              Inventory definitions
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item :to="'/inventory/inventory-definition/view/' + definition.id">
              {{ definition.name }}
            </v-breadcrumbs-item>
            <span class="pl-2 pr-2">/</span>
            <v-breadcrumbs-item disabled>
              build {{ build.id }}
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-layout align-center>
            <img class="c-align-self-start" src="@/assets/img/illustrations/recipe.png" alt="cardboard box" width="50px">
            <div class="headline font-weight-medium">
              Edit build
            </div>
            <v-spacer></v-spacer>
            <t-item-diff v-if="$store.state.settings.debugMode" :item1="lastSave" :item2="merged">
              <v-layout 
              slot="item1Header"
              align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                Last save
              </v-layout>
              <v-layout 
              slot="item2Header"
              align-center class="subheading font-weight-bold pl-2 crx-toolbar">
                LIVE
              </v-layout>
            </t-item-diff>
            <transition mode="out-in" name="scale-transition">
              <v-btn
              v-if="isDirty"
              key="1"
              color="color1"
              class="white--text ma-0"
              :loading="saving"
              depressed
              @click="save">
              Save
              </v-btn>
            </transition>
          </v-layout>

        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs">
          <v-layout align-center>
            <v-btn
            icon
            round 
            @click="goBack">
              <v-icon color="color1">arrow_back</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Build
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div>
      <v-container>

        <!-- TOOLBAR -->
        <v-layout>

          <v-tooltip bottom open-delay="100">
            <template v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              @click="importBuild"
              class=""
              >
                <v-icon>mdi-file-import</v-icon>
              </v-btn>
            </template>
            <span>Import build</span>
          </v-tooltip>

        </v-layout>
        
        <!--
        <v-layout>
          <v-flex xs6>
            MERGED
          </v-flex>
          <v-flex xs6>
            LAST SAVE
          </v-flex>
        </v-layout>
        <t-string-diff :string1="merged" :string2="lastSave">

        </t-string-diff>
        -->
        
        
        <v-card class="pa-2">
          <v-layout mt-3>
            <v-flex xs3 class="left-label">
              Build name
            </v-flex>
            <v-flex xs9>
              <c-input :value.sync="formData.buildName" class="crx-box-input"></c-input>
            </v-flex>
          </v-layout>
        </v-card>

        <v-card class="mt-2">
          <raw-materials :id="id" :itemsSource="formData.rawMaterials" :netWeight.sync="formData.netWeight">
          </raw-materials>
        </v-card>

        <v-card class="mt-2">
          <packaging :id="id" :itemsSource="formData.packaging">

          </packaging>
        </v-card>

      </v-container>
    </div>

    <!-- DIALOGS -->
     <select-build-dialog ref="selectBuildDialog"></select-build-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import GoBack from '@/mixins/GoBack'
import RawMaterials from './components/RawMaterials'
import Packaging from './components/Packaging'
import Vue from 'vue'
import SelectBuildDialog from '@/components/dialogs/select-build/Dialog'

export default {
  props: ['id'],
  mixins: [GoBack],
  components: {
    RawMaterials,
    Packaging,
    SelectBuildDialog
  },
  data () {
    return {
      build: {},
      definition: {},
      lastSave: {
        buildName: null,
        netWeight: 0,
        rawMaterials: '[]',
        packaging: '[]'
      },
      formData: {
        buildName: null,
        netWeight: 0,
        rawMaterials: [],
        packaging: []
      },
      saving: false
    }
  },
  computed: {
    isDirty () {
      return !_.isEqual(this.lastSave, this.merged)
    },
    merged () {
      var merged = {}
      merged.buildName = this.formData.buildName
      merged.netWeight = this.formData.netWeight || 0
      merged.rawMaterials = this.cloneAndSort(this.formData.rawMaterials)
      merged.packaging = this.cloneAndSort(this.formData.packaging)
      return merged
    }
  },
  methods: {
    importBuild () {
      this.$refs.selectBuildDialog.open(null)
        .then((build) => {
          console.log(build)
          this.formData.netWeight = build.net_weight || 0
          this.formData.buildName = build.name + ' (copy)'
    
          var rawMaterials = build.items.filter(item => item.type === 0)
          var packaging = build.items.filter(item => item.type === 1)
          this.formData.rawMaterials = JSON.parse(JSON.stringify(rawMaterials))
          this.formData.packaging = JSON.parse(JSON.stringify(packaging))
          // change the id's so you don't overwrite the old recipe referenced on save!
          this.formData.rawMaterials.map(item => {
            item.id = null
            item.tempID = null
          })
          this.formData.packaging.map(item => {
            item.id = null
            item.tempID = null
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    cloneAndSort (arr) {
      var copy = JSON.parse(JSON.stringify(arr))
      copy.sort((a, b) => a.tempID - b.tempID)
      copy = copy.map(o => Object.assign(o, {
        percent: (o.percent || '').toString(),
        quantity: (o.quantity || '').toString()
      }))
      return copy
    },
    postSaveUpdateIds (localArray, responseArray) {
      for (var row of responseArray) {
        var item = localArray.find(item => {
          return item.tempID === row.tempID
        })
        Vue.set(item, 'id', row.id)
      }
      return localArray
    },
    save () {
      var data = {
        id: this.id,
        name: this.formData.buildName,
        netWeight: this.formData.netWeight,
        rowsRM: this.formData.rawMaterials,
        rowsPKG: this.formData.packaging
      }
      this.saving = true
      console.log(data)
      this.$axios.patch('product-builds/update',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.lastSave.buildName = data.name
            this.lastSave.netWeight = data.netWeight || 0
            this.formData.rawMaterials = this.postSaveUpdateIds(this.formData.rawMaterials, response.data.rowsRM)
            this.lastSave.rawMaterials = this.cloneAndSort(this.formData.rawMaterials)
            this.lastSave.packaging = this.cloneAndSort(this.postSaveUpdateIds(this.formData.packaging, response.data.rowsPKG))
          })
        .catch(
          (error) => {
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.saving = false
        })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        var build
        var definition
        this.$axios.get(`/product-builds/${this.id}`)
        .then(response => {
          var hrend = response.data.execution_time
          build = response.data.build
          console.log('WUTANG')
          console.log(response)
          console.log(build)
          return this.$axios.get(`/inventory-definitions/${build.inventory_item_id}`)
        })
        .then(response => {
          definition = response.data
          resolve({build, definition})
        })
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }, 150, {leading: true})
  },
  mounted () {
    this.loadAPI()
      .then(({build, definition}) => {
        this.build = build
        this.definition = definition
        this.formData.buildName = build.name
        this.formData.netWeight = build.net_weight || 0
        this.formData.rawMaterials = build.items.filter(item => item.type === 0)
        this.formData.packaging = build.items.filter(item => item.type === 1)

        console.log(build)

        this.$nextTick(() => {
          this.lastSave.buildName = this.formData.buildName
          this.lastSave.netWeight = this.formData.netWeight || 0
          this.lastSave.rawMaterials = this.cloneAndSort(this.formData.rawMaterials)
          this.lastSave.packaging = this.cloneAndSort(this.formData.packaging)
        })
      })
  }
}
</script>

<style scoped>
.left-label {
  padding-top: 10px;
  padding-right: 16px;
  text-align: right;
  font-size: 14px;
}
</style>
